/* lua.js generated code 0.3.0 */

var UserProductTypeBase = require("clover/logic/userProduct/UserProductTypeBase")
let AIPkgManager = require("activity/AIPackage/AIPkgManager");

var UserProductTypeWechatgame = xClass("UserProductTypeWechatgame", UserProductTypeBase)
UserProductTypeWechatgame.prototype.getProductInfo = function (successCallback, failCallback, timeoutCallback, cancelCallback) {
    var self = this
    if (self.finishLoadOnline) {
        self.finishLoadOnline = false
        if (type(successCallback) === "function") {
            var ret = table()
            for (var k in self.productInfo) {
                var v = self.productInfo[k]
                table.insert(ret, v)
            }
            successCallback(ret)
        }
        return 
    }
    var productMeta = clone(MetaManager.getInstance().product_wechatgame || table())
    //let isFirstPay = UserManager.getInstance().isFirstPay() > 0 ? true : false
    self.productInfo = table()
    for (let i in productMeta) {
        let v = productMeta[i]
        if (!v) {
            continue
        }
        
        if (v.show === 1) {
            let goodsMeta = MetaManager.getInstance().getGoodsMeta(v.goodsId || 0)
            if (type(goodsMeta) === "table" && goodsMeta.on === 1) {
                //if (isFirstPay) {
                    //if (v.firstPay === 1) {
                        self.productInfo[v.id] = v
                    //}
                //}else if(!v.firstPay){
                    //self.productInfo[v.id] = v
                //}
            }
        }else if( v.show === 0 && v.itemKey){
            self.productInfo[v.id] = v
        }
    }
    self.finishLoadOnline = true
    cc.log("wx productInfo:", self.productInfo)
    self.getProductInfo(successCallback, failCallback, timeoutCallback, cancelCallback)
}
UserProductTypeWechatgame.prototype.getCashInfo = function (successCallback, failCallback, timeoutCallback, cancelCallback) {
    var self = this
    self.getProductInfo(function (ret) {
        if (type(successCallback) === "function") {
            var res = table([1, "list", table()])
            for (var i = 1, v = ret[1]; v; i++, v = ret[i]) {
                if (!v.tag) {
                    var meta = clone(v)
                    meta.price = meta.price * 100
                    table.insert(res.list, meta)
                }
            }
            table.sort(res.list, function (a, b) {
                return a.price < b.price
            })
            successCallback(table([0, res]))
        }
    }, failCallback, timeoutCallback, cancelCallback)
}
UserProductTypeWechatgame.prototype.canBuyProduct = function (productId) {
    var self = this
    if (!self.productInfo[productId]) {
        return [false, ZooErrorCode.BUY_PRODUCTID_INVALID]
    }
    return [true]
}
UserProductTypeWechatgame.prototype.deal = function (productId, successCallback, failCallback, cancelCallback, source = ModuleName.BUY_RMB_COINS, dcCashData = null) {
    var self = this
    let loadId = LoadingPanelLogic.getInstance().add("购买中，请耐心等待...", cancel)
    function removeAnim() {
        if (loadId) {
            LoadingPanelLogic.getInstance().remove(loadId)
            loadId = null
        }
    }
    function fail(event) {
        removeAnim()
        cc.log("wx buy->deal->fail:", JSON.stringify(event))
        // dcCashData.session, dcCashData.scence, dcGoodsId
        let dcGoodsId = "";
        if (AIPkgManager.IsAiPackage(productId)) {
            let productMeta = AIPkgManager.getInstance().getPackageMeta(productId);
            if (productMeta) {
                dcGoodsId = productMeta.package_id;
            }
        } else {
            let productMeta = self.productInfo[productId]
            if (!productMeta) productMeta = MetaManager.getInstance().getProductMetaByID(productId)
            if (productMeta) {
                dcGoodsId = productMeta.goodsId;
            }
        }
        let orderId = ""
        let reason = ""
        if (event){
            orderId = event.orderId
            if (event.code){
                reason = reason + " code: "+event.code
            }
            if (event.data){
                reason = reason + " data: "+event.data
            }
        }
        cc.log("支付失败 orderId ",orderId)
        cc.log("支付失败 reason ",reason)
        cc.log("支付失败 dcGoodsId ",dcGoodsId)
        cc.log("支付失败 dcCashData ",dcCashData)
        let session = ""
        let scence = ""
        let entry = ""
        let price = ""
        if (dcCashData){
            session = dcCashData.session
            scence = dcCashData.scence
            entry = dcCashData.entry
            price = dcCashData.price
            if(dcCashData.goodsId) {
                dcGoodsId = dcCashData.goodsId
            }
        }

        DCAssist.dc4BuyCashGoodsFail(session, scence,dcGoodsId,reason,orderId,entry, price, dcCashData)
        
        if (event && event.code == "760810"){
            hideGlobalMask("aiRevive");//ai礼包屏蔽了点击 这里得放开不然会导致 弹框无法关闭
            hideGlobalMask("aiMarket");
            require("clover/sns/SnsProxy").getInstance().showDialog({
                text: getText("error.tip.760810"),
                needOkBtn: true,
                okBtnText: "确定",
            }, () => {
                if (type(failCallback) === "function") {
                    failCallback(event)
                }
            })
        }else{ 
            if (type(failCallback) === "function") {
                failCallback(event)
            }
        }
    }
    function cancel() {
        removeAnim()
        if (type(cancelCallback) === "function") {
            cancelCallback()
        }
    }
    function onSuccess(special) {
        let product_str, rmb, itemid, dcGoodsId, ext
        if (special === "aiPackage") {
            itemid = productId;
            let productMeta = AIPkgManager.getInstance().getPackageMeta(productId);
            cc.log("wx buy->deal productMeta:", productMeta)
            if (!productMeta) {
                fail()
                return;
            }
            product_str = productMeta.productId;
            rmb = productMeta.rmb / 10; // ai礼包价格使用分计算的，需要标准化为角
            dcGoodsId = productMeta.package_id;
        }else if (special == ModuleName.FESTIVAL_8TH_SHOP ){
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10

        }else if (special == ModuleName.SECRET_SHOP ){
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10
            product_str = dcCashData.productId
            cc.log("hw buy->deal product_str:", product_str)
        } else if (special == ModuleName.SALVAGE_GIFT){
            dcGoodsId = dcCashData.goodsId
            rmb = dcCashData.price * 10
            product_str = dcCashData.extProductId
        }else if(special == ModuleName.TRINITY_GIFT_BAG) {
            dcGoodsId = productId;
            rmb = dcCashData.price * 10;
            product_str = dcCashData.extProductId
        } else {
            itemid = GameProxy.getInstance().getItemIDById(productId)
            let productMeta = self.productInfo[productId]
            cc.log("wx buy->deal productMeta:", productMeta)
            if (!productMeta) productMeta = MetaManager.getInstance().getProductMetaByID(productId)
            if (!productMeta) {
                fail()
                return
            }
            product_str = productMeta.productId
            rmb = productMeta.cash
            dcGoodsId = productMeta.goodsId;
            ext = productMeta.ext;

        }
        function success(payData) {            
            let tradeId = payData && payData.orderId || `${UserManager.getInstance().uid}_${dcGoodsId}_${Localhost.timeInSec()}`;
            removeAnim();

            // 格子广告用
            MetaManager.getInstance().gridAdConfig.pay30day = true;
            MetaManager.getInstance().interstitialAdConfig.pay30day = true;

            DCAssist.dc4UseCurrencyWin32(dcGoodsId, 1, source, rmb * 10, tradeId) //source作为sceneName传入 应要求 scene source module  等都最后记录到category中
            UserDeal.getInstance().deliverGoods(dcGoodsId, 1, source, {"trade_id": tradeId, "item_worth": ItemWorth.RMB});

            UserManager.getInstance().addPayRecord(rmb /10);
            GoldElysiumManager.getInstance().addPayRecord(rmb / 10)

            if (dcCashData) {
                if (UserManager.getInstance().canIosToMiniPay()){
                    //
                    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame && (DnSdkTool.getInstance().isOpenAllReport() || UserManager.getInstance().getIosPayType() == "mini")) {
                        DnSdkTool.getInstance().onPurchase(rmb ? rmb * 10 : 0);
                    }

                    DCAssist.dc4IosGetCashGoods(
                        dcCashData.session, 
                        dcCashData.scence, 
                        dcGoodsId, 
                        dcCashData.entry, 
                        dcCashData.hasOwnProperty("price")? dcCashData["price"]: rmb / 10, 
                        payData.orderId,
                        dcCashData
                    ) 
                }else {
                    DCAssist.dc4GetCashGoods(
                        dcCashData.session, 
                        dcCashData.scence, 
                        dcCashData.hasOwnProperty("goodsId")? dcCashData["goodsId"]: dcGoodsId, 
                        dcCashData.entry, 
                        dcCashData.hasOwnProperty("price")? dcCashData["price"]: rmb / 10, 
                        payData.orderId,
                        dcCashData
                    );
                }
            }
            
            if (type(successCallback) === "function") {                
                successCallback(payData)
            }
        }
        // payment.buy(uid, product_str, itemid, rmb, rmb, success, fail, cancel)
        let data = {
            uid : UserManager.getInstance().uid,
            productId : product_str,
            itemId : itemid,
            money : rmb / 10,
            dcGoodsId : dcGoodsId,
            dcSession : dcCashData ? dcCashData.session : "",
            dcScence : dcCashData ? dcCashData.scence : "",
            dcEntry : dcCashData ? dcCashData.entry : "",
            dcSource : source
        }
        if (special === "aiPackage") {
            if(itemid > 7000000) {
                data.ext = {
                    aiGiftBagDailyBindId: itemid,
                }
            }else{
                data.ext = {
                    aiGiftBagId: AIPkgManager.getInstance().getLeaderId(itemid),
                    aiGiftBagType: AIPkgManager.getInstance().getPackageType(itemid)
                }
            }
        }else if (ext){
            data.ext = ext;
        }else if (dcCashData.ext){
            data.ext = dcCashData.ext
        }
        GameProxy.getInstance().buyProduct(data, success, fail, cancel, false)
    }

    if (AIPkgManager.IsAiPackage(productId)) {
        onSuccess("aiPackage");
    }else if (dcCashData && dcCashData.scence == ModuleName.FESTIVAL_8TH_SHOP){
        onSuccess(ModuleName.FESTIVAL_8TH_SHOP);
    }else if (dcCashData && dcCashData.scence == ModuleName.SECRET_SHOP){
        onSuccess(ModuleName.SECRET_SHOP);
    }else if(TrinityGiftBagManager.getInstance().isTrinityGiftBag(productId)) {
        onSuccess(ModuleName.TRINITY_GIFT_BAG);
    } else if (SalvageGiftManager.getInstance().isSalvageGift(productId)){
        onSuccess(ModuleName.SALVAGE_GIFT);
    }else {
        let productMeta = MetaManager.getInstance().getProductMetaByID(productId)
        if(productMeta.giftBagId && productMeta.giftBagId !== 0) {
            let http = ValideGiftBagHttp.new(true)
            http.addEventListener(Events.kComplete, onSuccess)
            http.addEventListener(Events.kError, fail)
            http.addEventListener(Events.kCancel, cancel)
            http.load(productMeta.giftBagId)
        }else {
            onSuccess()
        }
    }    
}

module.exports = UserProductTypeWechatgame
